import {Component, Inject, OnInit} from '@angular/core';
import {TestResult} from '../../../data/models/result/test-result';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-result-cancel-dialog',
  templateUrl: './test-result-cancel-dialog.component.html',
  styleUrls: ['./test-result-cancel-dialog.component.css']
})
export class TestResultCancelDialogComponent implements OnInit {

  testResult: TestResult;

  constructor(
    private testResultService: TestResultService,
    public dialogRef: MatDialogRef<TestResultCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testResult: TestResult,
    },
  ) {
    this.testResult = data.testResult;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testResultService.cancelTestResult(this.testResult.id)
      .then(testResult => {
        this.dialogRef.close(testResult);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
